import {RREventType} from "../../types/RREventType";
import {RRCalendarDateDataType} from "../../types/RRCalendarDataType";
import {useAppSelector} from "../../hooks";
import {selectAllEmployees,} from "../../../features/AppDataSlice";
import {timeToString} from "../../tools";
import {useMemo, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";
import {utils, writeFile} from "xlsx";
import {selectDepartment} from "../../../features/AppStateSlice";

const EventDetailsModal = (props: { event: RREventType, eventData: RRCalendarDateDataType, onClose: () => void }) => {
    const allEmployees = useAppSelector(selectAllEmployees);
    const tableRef = useRef<HTMLTableElement>(null);
    const activeDepartment = useAppSelector(selectDepartment);

    function exportTable() {
        const workbook = utils.table_to_book(tableRef.current, {raw: true});
        writeFile(workbook, `${props.event.eventNumber}-${props.event.eventName}-${props.eventData.date}.xlsx`);
    }

    const departmentEmployees = useMemo(() => {
        return allEmployees.filter(
            value => (
                (activeDepartment === "store" && value.isStore) ||
                (activeDepartment === "montage" && value.isMontage) ||
                (activeDepartment === "catering" && value.isCatering)
            ) && value.isEmployee
        );
    }, [allEmployees, activeDepartment]);

    return (
        <div className="modal fade show" tabIndex={-1} role="dialog" style={{display: "block"}}>
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-title">
                            <h5 className="mb-0">Детайли за събитие</h5>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                onClick={props.onClose}/>
                    </div>
                    <div className="modal-body">
                        <table className={"w-100 table "} ref={tableRef} >
                            <thead>
                            <tr>
                                <th/>
                                <th>Дата:</th>
                                <th colSpan={7}><b>{ props.eventData.date }</b></th>
                            </tr>
                            <tr>
                                <th/>
                                <th>Събитие:</th>
                                <th colSpan={7}><b>[{ props.event.eventNumber }] { props.event.eventName }</b></th>
                            </tr>
                            <tr>
                                <th/>
                                <th>Място:</th>
                                <th colSpan={7}><b>{ props.event.place }</b></th>
                            </tr>
                            <tr>
                                <th/>
                                <th colSpan={8}>&nbsp;</th>
                            </tr>
                            <tr>
                                <th>#</th>
                                <th>Служител</th>
                                <th>ЕГН</th>
                                <th>Начало</th>
                                <th>Край</th>
                                <th>Почивка</th>
                                <th>Бонус</th>
                                <th>Подпис</th>
                                <th>Забележки</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                props.eventData.items
                                    .filter(employee =>
                                        employee.eventId === props.event.id &&
                                        departmentEmployees.findIndex(e => e.id === employee.employeeId) !== -1)
                                    .map((employee, index) => {
                                    const empl = departmentEmployees.find(e => e.id === employee.employeeId);

                                    return (
                                        <tr key={employee.id}>
                                            <td>{index + 1}</td>
                                            <td>{empl?.name}</td>
                                            <td><span>{empl?.egn}</span></td>
                                            <td>{timeToString(employee.eventDayStart)}</td>
                                            <td>{timeToString(employee.eventDayEnd)}</td>
                                            <td>{employee.restTime || ""}</td>
                                            <td>{employee.bonus || ""}</td>
                                            <td/>
                                            <td>{employee.notes}</td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" onClick={() => {
                            exportTable()
                        }}>
                            <FontAwesomeIcon icon={faFileExcel} />&nbsp;Експорт</button>&nbsp;
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"
                                onClick={props.onClose}>Затвори
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EventDetailsModal;
